import { LOAD_SUCCESS } from './auth';

const INIT = 'kyc/INIT';
const INIT_SUCCESS = 'kyc/INIT_SUCCESS';
const INIT_FAIL = 'kyc/INIT_FAIL';
const DRAWUP = 'kyc/DRAWUP';
const DRAWUP_SUCCESS = 'kyc/DRAWUP_SUCCESS';
const DRAWUP_FAIL = 'kyc/DRAWUP_FAIL';

const initialState = {
  userKey: null,
  status: null,
};

export default function kyc(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS:
      return {
        ...state,
        status: action.result.kycStatus,
      };
    case INIT_SUCCESS:
      if (action.result.status) {
        return {
          ...state,
          status: action.result.status,
        };
      }
      return {
        ...state,
        userKey: action.result.user_key,
      };
    case DRAWUP_SUCCESS:
      return {
        ...state,
        status: 'PENDING',
      };
    default:
      return state;
  }
}

export function init() {
  return {
    types: [INIT, INIT_SUCCESS, INIT_FAIL],
    promise: async ({ client }) => {
      const { data } = await client.get('/v1/kyc/init');
      return data;
    },
  };
}
export function drawup(identityAccessKey) {
  return (dispatch, getState) => {
    const state = getState();
    return dispatch({
      types: [DRAWUP, DRAWUP_SUCCESS, DRAWUP_FAIL],
      promise: async ({ client }) => {
        await client.post('/v1/kyc/drawup', {
          user_key: state.kyc.userKey,
          access_key: identityAccessKey,
        });
      },
    });
  };
}
